<template>
  <span class="color">
    <color-preview class="color__preview" :value="value"/>
    <span class="color__name">{{value.name}}</span>
  </span>
</template>

<script>
import ColorPreview from '@/components/ColorPreview';

export default {
  name: 'color',
  components: {
    ColorPreview,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.color__preview + .color__name {
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// Color.vue?b605b78c